import { Photo } from "../../svg";
export default function AddToYourPost({ setShowPrev, onFeelingActivityClick, onTagClick, onLocationClick }) {
  return (
    <div className="addtoyourpost">
      <div className="addto_text">Add to your publication</div>
      <div
        className="post_header_right hover1"
        onClick={() => {
          setShowPrev(true);
        }}
      >
        <Photo color="#45bd62" />
      </div>
      <div 
        className="post_header_right hover1"
        onClick={onTagClick}
      >
        <i className="tag_icon"></i>
      </div>
      {/* <div 
        className="post_header_right hover1"
        onClick={onFeelingActivityClick}
      >
        <Feeling color="#f7b928" />
      </div> */}
      <div 
        className="post_header_right hover1"
        onClick={onLocationClick}
      >
        <i className="maps_icon"></i>
      </div>
    </div>
  );
}
